import { useRef, useEffect, useState } from "react";
import sofar_banner from "../../../assets/sofar_banner.png";
import '../AlphaEss.css';
import { Link } from 'react-router-dom';

const productName = "SOFAR";

export default function ProductHero() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className={`alpha-proven-brands-section ${inView ? "alpha-hero-in-view" : ""}`}>
      <div className="alpha-brands-content">
        <div className="alpha-brands-image-container">
          <img
            src={sofar_banner}
            alt="SOFAR solar and battery system"
            className="alpha-brands-image"
          />
        </div>
        <div className="alpha-brands-info-card">
          <h1>{productName}</h1>
          <h2>Energy to power your life</h2>
          <p className="alpha-info-footer-list">
            {productName} PowerAll delivers reliable and intelligent home energy storage with advanced built-in safety protection, providing secure and efficient power for Australian homes.
          </p>
          <div className="free_quote_div">
            <Link to="/contact" className="free_quote_btn">
              Get Free Quote
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
